import { useTheme } from '../theme/ThemeContext';

export function ThemeToggle({ title = 'Toggle dark/light mode' }: { title?: string }) {
  const { theme, toggleTheme } = useTheme();
  return (
    <div className="theme-toggle" onClick={toggleTheme} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && toggleTheme()} title={title} aria-label={title}>
      <div className="theme-toggle-slider" aria-hidden="true">
        {theme === 'dark' ? '☀️' : '🌙'}
      </div>
    </div>
  );
}
